import { AppShell } from '@/components/layout/AppShell';
import { ButtonLink, EmptyState } from '@/components/ui';
import { paths } from '@/routes/paths';

/** 404. Named the same way the API names it: "we could not find what you wanted". */
export function NotFoundPage() {
  return (
    <AppShell title="Page not found" titleHidden>
      <EmptyState
        glyph="🔍"
        title="We couldn't find that page"
        description="The link may be out of date, or the order it pointed to may have been completed."
        action={<ButtonLink to={paths.home}>Go to the home page</ButtonLink>}
      />
    </AppShell>
  );
}
